export const GET_PARTICIPANTS_BEGIN = "GET_PARTICIPANTS_BEGIN"
export const GET_PARTICIPANTS_SUCCESS = "GET_PARTICIPANTS_SUCCESS"
export const GET_PARTICIPANTS_FAILURE = "GET_PARTICIPANTS_FAILURE"

export const ADD_PARTICIPANT_BEGIN = "ADD_PARTICIPANT_BEGIN"
export const ADD_PARTICIPANT_SUCCESS = "ADD_PARTICIPANT_SUCCESS"
export const ADD_PARTICIPANT_FAILURE = "ADD_PARTICIPANT_FAILURE"

export const GET_ACTIVITIES_BEGIN = "GET_ACTIVITIES_BEGIN"
export const GET_ACTIVITIES_SUCCESS = "GET_ACTIVITIES_SUCCESS"
export const GET_ACTIVITIES_FAILURE = "GET_ACTIVITIES_FAILURE"

export const GetParticipantsBegin = () => ({
  type: GET_PARTICIPANTS_BEGIN
})

export const GetParticipantsSuccess = participants => ({
  type: GET_PARTICIPANTS_SUCCESS,
  payload: { participants }
})

export const GetParticipantsFailure = error => ({
  type: GET_PARTICIPANTS_FAILURE,
  payload: { error }
})

export const AddParticipantBegin = () => ({
  type: ADD_PARTICIPANT_BEGIN
})

export const AddParticipantSuccess = participants => ({
  type: ADD_PARTICIPANT_SUCCESS,
  payload: { participants }
})

export const AddParticipantFailure = error => ({
  type: ADD_PARTICIPANT_FAILURE,
  payload: { error }
})

export const GetActivitiesBegin = () => ({
  type: GET_ACTIVITIES_BEGIN
})

export const GetActivitiessSuccess = activities => ({
  type: GET_ACTIVITIES_SUCCESS,
  payload: { activities }
})

export const GetActivitiesFailure = error => ({
  type: GET_ACTIVITIES_FAILURE,
  payload: { error }
})
